const toggleAccordion = (el) => {
    const accordionContent = el.parentNode

    var all = document.getElementsByClassName('accordion-content')

    if (accordionContent.classList.contains('open')) {
        accordionContent.classList.remove('open')
    } else {
        for(var i  = 0; i < all.length; i++) {
            all[i].classList.remove('open');
        }
        accordionContent.classList.add('open')
        return true;
    }
}
